/*******************************************************************************
  설  명 : 고객센터 > 협회지
  작성자 : 송영석
  작성일 : 2020-05-18
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule, NgbModal, NgbActiveModal, NgbModalOptions, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { MagazineService } from '@app/home/service/magazine.service';
import { Globals } from '@app/service/globals.service';
import { config } from '@app/service/config.service';

import { ToastrService } from 'ngx-toastr';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

import { MagazineContentsComponent } from '@home/page/customer-center/magazine/magazine-contents/magazine-contents.component';

const options: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: 'lg',
  centered: true
};

@Component({
  selector: 'app-magazine',
  templateUrl: './magazine.component.html',
  styleUrls: ['./magazine.component.scss']
})
export class MagazineComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public params: any = {
    no: 1,
    row: 6
  }

  public baseURL: any = config.baseUrl;

  public magazineList: any = [];
  public totalCount: any = 0;
  public maxSize: any = 10;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private modalService: NgbModal,
    private magazineService: MagazineService,
    private globals: Globals
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    if ( window.innerWidth <= 720 ) {
      this.maxSize = 3;
    }
  }

  /*******************************************************************************
    설  명 : 데이터 로딩 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.params.row = ( typeof params.row == 'undefined' || params.row == '' ) ? '6' : params.row;
      this.params.no = ( typeof params.no == 'undefined' || params.no == '' ) ? '1' : params.no;

      this.getMagazineList();
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getMagazineList() {
    // indicator 표시 숨김
    setTimeout (() => {
      this.globals.indicator.next(true);
    });

    this.magazineService.getMagazineList( this.params ).then( response => {
      if( response.ResultCode ) {
        this.magazineList = response.data;
        this.totalCount = response.total;
      } else {
        this.magazineList = [];
        this.totalCount = 0;
      }

      console.log( response );

      this.globals.indicator.next(false);
    });
  }

  /*******************************************************************************
    설  명 : 목차보기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  openMagazine(item) {
    const modalRef = this.modalService.open(MagazineContentsComponent, options);

    modalRef.componentInstance.image = item.file_name2;

    modalRef.result.then((result) => {
      if( result ) {
      }
    }, (reason) => {
    });
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage( page ) {
    this.params.no = page;

    this.router.navigate(
    [location.pathname],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

}
